import DocumentConfiguration from '../../../document/pages/Configuration';
import * as DocumentQueries from './queries.tsx';
import { GET_OVERVIEW_DATA } from '../queries.ts';
import { CHANNEL_CONFIG_PATH, CHANNEL_PATH, OVERVIEW_PATH } from '../constants.ts';
import React from 'react';
import { DocumentType } from '../../../document/constants.ts';
import { DocumentTypeName, ValidationCheck } from '../../../document/components/DocumentConfig.tsx';

const Configuration = (props) => {
    const documentConfiguration = {
        service: 'delivery_notes',
        documentType: DocumentType.DeliveryNote,
        documentTypeName: 'deliveryNote',
        activeTab: 'delivery-note',
        documentQueries: DocumentQueries,
        getOverviewData: GET_OVERVIEW_DATA,
        channelPath: CHANNEL_PATH,
        overviewPath: OVERVIEW_PATH,
        configPath: CHANNEL_CONFIG_PATH,
        documentTypes: [
            DocumentTypeName.DeliveryNote,
            DocumentTypeName.Invoice,
            DocumentTypeName.Offer,
            DocumentTypeName.Order,
            DocumentTypeName.OrderConfirmation,
            DocumentTypeName.RequestForQuotation,
        ],
        validationChecks: [
            ValidationCheck.TotalAmount,
            ValidationCheck.LineItemSum,
            ValidationCheck.PosNumber,
            ValidationCheck.ForgottenLineItems,
            ValidationCheck.IncompleteLineItems,
            ValidationCheck.CustomerInternalNote,
            ValidationCheck.ThousandSeparatorQuantity,
            ValidationCheck.UniqueDocumentNumber,
        ],
    };

    return <DocumentConfiguration documentConfiguration={documentConfiguration} {...props} />;
};

export default Configuration;
